import { ProveedorIdioma } from '@tallerya/i18n';
import { ProveedorAvisos } from '@tallerya/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ProveedorDatos } from './datos/ProveedorDatos';
import { Acceso } from './sesion/Acceso';
import { ProveedorSesion } from './sesion/ProveedorSesion';
import { ProveedorSucursal } from './sucursal/ProveedorSucursal';
import { ProveedorTaller } from './taller/ProveedorTaller';
// Los tokens primero: estilos.css los usa.
import '@tallerya/ui/tokens.css';
import './estilos.css';

const raiz = document.getElementById('root');
if (!raiz) {
  // El index.html siempre trae este div. Si falta, algo se rompió al compilar y
  // es mejor enterarse acá que ver una pantalla en blanco sin explicación.
  throw new Error('No encontré el div#root en index.html');
}

createRoot(raiz).render(
  // StrictMode solo actúa en desarrollo: monta cada componente dos veces para
  // destapar efectos que no se limpian. Molesta al principio y encuentra bugs
  // que de otro modo aparecen en producción.
  <StrictMode>
    {/* El idioma envuelve al router, no al revés: cambiar de idioma no debería
        cambiar de ruta ni al revés. */}
    <ProveedorIdioma>
      {/* Y la sesión envuelve a la aplicación entera, por dos razones:

          - al volver de Keycloak hay que canjear el código que viene en la URL
            **antes** de dibujar nada, o la primera pantalla sale sin sesión y
            parpadea cuando llega;
          - la renovación silenciosa corre mientras la aplicación viva, no
            mientras una pantalla esté montada. */}
      <ProveedorSesion>
        {/* Quien entró sin ser de un taller se queda en la puerta (#168). Va
            antes de los datos para que no salga ninguna consulta a su nombre. */}
        <Acceso>
          {/* Los datos van DENTRO de la sesión, no al revés: cada consulta manda
              el token, así que la caché no puede existir antes que él. Al revés,
              la primera consulta saldría sin credenciales. */}
          <ProveedorDatos>
            {/* El taller elegido (#205), dentro de los datos porque la lista sale
                de la API, y por fuera de todo lo demás: ninguna pantalla se dibuja
                —ni pide nada— hasta saber en qué taller se trabaja. */}
            <ProveedorTaller>
              {/* Los avisos («Se guardó…») van por fuera de las rutas: se guarda
                  en una pantalla y el aviso se ve en la siguiente. */}
              <ProveedorAvisos>
                {/* La sucursal elegida, dentro del taller porque es una sucursal
                    de ese taller. Envuelve a toda la aplicación: la elige el app
                    bar y la leen las pantallas. */}
                <ProveedorSucursal>
                  <App />
                </ProveedorSucursal>
              </ProveedorAvisos>
            </ProveedorTaller>
          </ProveedorDatos>
        </Acceso>
      </ProveedorSesion>
    </ProveedorIdioma>
  </StrictMode>,
);
